import { Divider, Group, Text } from "@mantine/core";
import type { JSX } from "react";
import type { ChatTask } from "@/sdk";
import { CustomerMdn } from "./CustomerMdn";
import { CustomerName } from "./CustomerName";

export const CustomerDetails = ({
    customerName,
    mdn,
    hideDivider,
    showCopyMdnIcon,
}: Pick<ChatTask, "mdn" | "customerName"> & { hideDivider?: boolean; showCopyMdnIcon?: boolean }): JSX.Element => {
    const SeparatorComponent = hideDivider ? "-" : <Divider orientation="vertical" color="dark.3" />;

    if (customerName.error && mdn.error)
        return (
            <Text span fw="bold" size="sm">
                Customer info missing
            </Text>
        );

    const placeholderWidth = 84;
    return (
        <Group gap={hideDivider ? "3xs" : "xs"} wrap="nowrap">
            <CustomerName
                customerName={customerName}
                size="sm"
                width={placeholderWidth}
                truncate={{ maxChars: 22 }}
                lineClamp={1}
            />
            {SeparatorComponent}
            <CustomerMdn mdn={mdn} width={placeholderWidth} showCopyMdnIcon={showCopyMdnIcon ?? false} />
        </Group>
    );
};
